import React, { useMemo } from 'react';
import zxcvbn from 'zxcvbn';

// Score → UI mapping. zxcvbn returns 0..4. We treat 0/1 as too weak and block submit.
const SCORES = [
  { label: 'Very weak', color: 'bg-red-500',     text: 'text-red-600',     width: 'w-1/5' },
  { label: 'Weak',      color: 'bg-orange-500',  text: 'text-orange-600',  width: 'w-2/5' },
  { label: 'Fair',      color: 'bg-yellow-500',  text: 'text-yellow-700',  width: 'w-3/5' },
  { label: 'Strong',    color: 'bg-lime-500',    text: 'text-lime-700',    width: 'w-4/5' },
  { label: 'Very strong', color: 'bg-emerald-500', text: 'text-emerald-700', width: 'w-full' },
];

export const MIN_PASSWORD_SCORE = 2; // require at least "Fair"

export function scorePassword(password, userInputs = []) {
  if (!password) return null;
  // zxcvbn is sync but a touch heavy; for password fields this is fine.
  return zxcvbn(password, userInputs);
}

const PasswordStrengthMeter = ({ password, userInputs = [], className = '' }) => {
  const result = useMemo(() => scorePassword(password, userInputs), [password, userInputs]);

  if (!password) return null;
  const score = result?.score ?? 0;
  const cfg = SCORES[score];
  const tip = result?.feedback?.warning || result?.feedback?.suggestions?.[0] || '';

  return (
    <div className={`mt-2 ${className}`} data-testid="password-strength-meter">
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
        <div className={`h-full ${cfg.color} ${cfg.width} transition-all duration-300`} />
      </div>
      <div className="flex items-center justify-between mt-1">
        <span className={`text-xs font-medium ${cfg.text}`} data-testid="password-strength-label">{cfg.label}</span>
        {tip && <span className="text-xs text-gray-500 truncate ml-2 max-w-[60%] text-right" title={tip}>{tip}</span>}
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;
